import React from 'react';
import { connect } from 'react-redux';

import { loadingGoogleMapsScriptFinished } from '../../../../pages/shared/reducer';

import { isWindowExists } from '../../../../helpers/windowHelper';

import { GOOGLE_MAPS_API_KEY } from '../../../../env';

const initPlacesAutocomplete = ComposedComponent => {
    class hoc extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                inited: false
            }
        }

        loadSciptFinished = () => {
            this.props.loadingGoogleMapsScriptFinished();
        }

        componentDidMount() {
            if (isWindowExists()) {
                const googleMapScriptIsPresent = document.getElementById("google-places-api") != null;
                if (!googleMapScriptIsPresent) {
                    window.loadSciptFinished = this.loadSciptFinished;
                    const gmapScriptEl = document.createElement(`script`);
                    gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&callback=loadSciptFinished`;
                    gmapScriptEl.id = 'google-places-api';
                    document.querySelector(`body`).insertAdjacentElement(`beforeend`, gmapScriptEl);
                }
            }
        }

        render() {
            return <ComposedComponent {...this.props} />
        }
    }

    return connect(
        mapState,
        mapDispatch
    )(hoc)
}

const mapState = (state) => {
    return {
    }
}

const mapDispatch = (dispatch) => {
    return {
        loadingGoogleMapsScriptFinished() {
            dispatch(loadingGoogleMapsScriptFinished())
        }
    }
}

export default initPlacesAutocomplete;